// extracted by css-extract-rspack-plugin
export default {"alert":"alert-M0MD9L"};